/**
 * Loan model (Formal vs Informal) and penalty evaluation schedule options.
 * Used for Flexible Repayment Loan System V2 - shared by web and aligned with backend.
 */

export const LOAN_MODEL = {
  FORMAL: "formal",
  INFORMAL: "informal",
};

export const LOAN_MODEL_OPTIONS = [
  { value: LOAN_MODEL.FORMAL, label: "Formal" },
  { value: LOAN_MODEL.INFORMAL, label: "Informal" },
];

export const PENALTY_EVALUATION_SCHEDULE = {
  LAST_FRIDAY: "last_friday",
  FIRST_FRIDAY: "first_friday",
  THIRD_SATURDAY: "third_saturday",
  FIXED_DAY: "fixed_day",
};

export const PENALTY_EVALUATION_SCHEDULE_OPTIONS = [
  { value: PENALTY_EVALUATION_SCHEDULE.LAST_FRIDAY, label: "Last Friday of month" },
  { value: PENALTY_EVALUATION_SCHEDULE.FIRST_FRIDAY, label: "1st Friday of month" },
  { value: PENALTY_EVALUATION_SCHEDULE.THIRD_SATURDAY, label: "3rd Saturday of month" },
  { value: PENALTY_EVALUATION_SCHEDULE.FIXED_DAY, label: "Fixed day of month" },
];

/** Week of month for interest application date (meeting date) – informal loans */
export const INTEREST_APPLICATION_WEEK = {
  FIRST: "first",
  SECOND: "second",
  THIRD: "third",
  FOURTH: "fourth",
  LAST: "last",
};

export const WEEK_OF_MONTH_OPTIONS = [
  { value: INTEREST_APPLICATION_WEEK.FIRST, label: "First week" },
  { value: INTEREST_APPLICATION_WEEK.SECOND, label: "Second week" },
  { value: INTEREST_APPLICATION_WEEK.THIRD, label: "Third week" },
  { value: INTEREST_APPLICATION_WEEK.FOURTH, label: "Fourth week" },
  { value: INTEREST_APPLICATION_WEEK.LAST, label: "Last week" },
];

/** Day of week for interest application date (meeting date) – informal loans */
export const INTEREST_APPLICATION_DAY = {
  MONDAY: "monday",
  TUESDAY: "tuesday",
  WEDNESDAY: "wednesday",
  THURSDAY: "thursday",
  FRIDAY: "friday",
  SATURDAY: "saturday",
  SUNDAY: "sunday",
};

export const DAY_OF_WEEK_OPTIONS = [
  { value: INTEREST_APPLICATION_DAY.MONDAY, label: "Monday" },
  { value: INTEREST_APPLICATION_DAY.TUESDAY, label: "Tuesday" },
  { value: INTEREST_APPLICATION_DAY.WEDNESDAY, label: "Wednesday" },
  { value: INTEREST_APPLICATION_DAY.THURSDAY, label: "Thursday" },
  { value: INTEREST_APPLICATION_DAY.FRIDAY, label: "Friday" },
  { value: INTEREST_APPLICATION_DAY.SATURDAY, label: "Saturday" },
  { value: INTEREST_APPLICATION_DAY.SUNDAY, label: "Sunday" },
];

/** Fallback when /enums is unavailable — keep in sync with App\Enums\InterestCalculationMode */
export const INTEREST_CALCULATION_MODE = {
  REDUCING_BALANCING: "REDUCING_BALANCING",
  STRAIGHT_LINE: "STRAIGHT_LINE",
  EQUAL_PRINCIPAL: "EQUAL_PRINCIPAL",
};

export const INTEREST_CALCULATION_MODE_OPTIONS = [
  {
    value: INTEREST_CALCULATION_MODE.REDUCING_BALANCING,
    label: "Reducing balance",
  },
  {
    value: INTEREST_CALCULATION_MODE.STRAIGHT_LINE,
    label: "Straight line",
  },
  {
    value: INTEREST_CALCULATION_MODE.EQUAL_PRINCIPAL,
    label: "Equal principal",
  },
];
